// Functions
import VerifyToken from "../../config/verifyToken";
import useReportAccess from "../../config/useReportAccess";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import SessionGraphicsView from "../../components/reports/sections/sessionGraphics";

const SessionGraphics = () => {
  useReportAccess("SESSION_GRAPHICS");

  return (
    <>
      {VerifyToken()}
      <Header />
      <Main>
        <StickyLogo />
        <SessionGraphicsView />
      </Main>
    </>
  );
};

export default SessionGraphics;
